// API errors (some could also be raised at the front-end)
export const MISSING_VALUES = 'MISSING_VALUES';
export const NOT_ENOUGH_ROWS = 'NOT_ENOUGH_ROWS';
export const NOT_ENOUGH_TEXT_COLUMNS = 'NOT_ENOUGH_TEXT_COLUMNS';
export const NOT_ENOUGH_NUMBER_COLUMNS = 'NOT_ENOUGH_NUMBER_COLUMNS';
export const WRONG_FORMAT = 'WRONG_FORMAT';
export const FILE_TOO_BIG = 'FILE_TOO_BIG';
export const UNKNOWN_ERROR = 'UNKNOWN_ERROR';
export const UNKNOWN_PROCESSING_ERROR = 'UNKNOWN_PROCESSING_ERROR';
// Other constants
export const NA_VALUES = ['None', 'NaN', 'NaT', 'NA', 'null', 'N/A', 'missing'];
